import { OVERVIEW, OVERVIEW_ERROR, OVERVIEW_HIDE_ERROR, OVERVIEW_START_LOADER, OVERVIEW_STOP_LOADER, } from "../interfaces/iFutureOverview";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const FutureQuoteOverviewReducer = (state = initState, action) => {
    switch (action.type) {
        case OVERVIEW: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case OVERVIEW_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case OVERVIEW_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case OVERVIEW_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case OVERVIEW_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default FutureQuoteOverviewReducer;
